import { createContext, useContext } from "react";

export interface AccordionItemDescriptorType {
  title: string;
  imageURL?: string;
}

export interface AccordionContextType {
  hovered: AccordionItemDescriptorType | null;
  setHovered(descriptor: AccordionItemDescriptorType | null): void;

  opened: AccordionItemDescriptorType | null;
  setOpened(descriptor: AccordionItemDescriptorType | null): void;
}

export const AccordionContext = createContext<AccordionContextType | null>(null);

export function useAccordion() {
  const ctx = useContext(AccordionContext);
  if (!ctx) {
    throw new Error("useAccordion must be used within a <AccordionContext/>");
  }

  return ctx;
}
